import { FC, useEffect, useState } from 'react';
import { BalancePath } from './container/BalancePath';
import { BrowserRouter } from 'react-router-dom';
import { NotificationProvider } from './context/notification-context/NotificationContext';
import { AppFooterComponent } from './components/app-footer/AppFooterComponent';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import {authConfig, logout} from './store/UserStore';
import MetaPixelPageViewComponent from './components/meta-pixel-page-view/MetaPixelPageViewComponent';
import GoogleAnalyticsPageViewComponent from './components/google-analytics-page-view/GoogleAnalyticsPageViewComponent';
import { ConsentManager } from './consent/ConsentManager';

const App: FC = () => {
    const { i18n } = useTranslation();
    const [lang, setLang] = useState(i18n.language);

    useEffect(() => {
        const handleLanguageChange = (lng: string) => {
            setLang(lng);
        };

        i18n.on('languageChanged', handleLanguageChange);

        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, [i18n]);

    useEffect(() => {
        const onStorage = (event: StorageEvent) => {
            if (event.key === 'authToken') {
                if(event.newValue === null) {
                    logout();
                } else if(event.newValue !== authConfig.value) {
                    authConfig.value = event.newValue;
                }
            }
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);

    return (
        <HelmetProvider>
            <div key={lang}>
                <Helmet htmlAttributes={{ lang: lang }}>
                    <meta
                        property='og:locale'
                        content={
                            lang === 'sr'
                                ? 'sr_RS'
                                : lang === 'de'
                                  ? 'de_DE'
                                  : lang === 'fr'
                                    ? 'fr_FR'
                                    : lang === 'ru'
                                      ? 'ru_RU'
                                      : 'en_US'
                        }
                    />
                </Helmet>
                <BrowserRouter>
                    <ConsentManager />
                    <GoogleAnalyticsPageViewComponent />
                    <MetaPixelPageViewComponent />
                    <NotificationProvider>
                        <div
                            style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}
                        >
                            <div style={{ flex: 1 }}>
                                <BalancePath />
                            </div>
                            <AppFooterComponent />
                        </div>
                    </NotificationProvider>
                </BrowserRouter>
            </div>
        </HelmetProvider>
    );
};

export default App;
